import { ref, onMounted, onUnmounted } from 'vue'

/** A `Date.now()` ref refreshed every `intervalMs`, so time-based computeds re-evaluate. */
export function useNow(intervalMs = 1000) {
	const now = ref(Date.now())
	let timer = null
	onMounted(() => {
		timer = setInterval(() => { now.value = Date.now() }, intervalMs)
	})
	onUnmounted(() => {
		if (timer) clearInterval(timer)
	})
	return now
}
